// Sub-pages for each product under Offerings > Products
import './ProductsSubPages.css';

const productData = {

  // ── UNGRID ────────────────────────────────────────────────────
  "product-ungrid": {
    icon: "",
    title: "UN Grid",
    badge: "Grid Intelligence Platform",
    tagline: "Unify your grid data. Unlock operational clarity.",
    color: "#E8601C",
    desc: "Ungrid is Inovaantage's advanced grid intelligence platform designed to unify disparate network datasets — from GIS and SCADA to smart meters and field systems — into a single, coherent operational picture. Ungrid enables utilities to move from reactive to predictive network management.",
    whyDifferent: [
      { icon: "🔗", title: "Unified Data Layer", desc: "Ingest, normalise, and federate data from GIS, SCADA, AMI, OMS, and ERP into one coherent model." },
      { icon: "📊", title: "Real-Time Network Visibility", desc: "Live network state awareness from substation to meter, with anomaly detection and alerting." },
      { icon: "🤖", title: "AI-Powered Predictions", desc: "Predictive fault detection, load forecasting, and asset health scoring using machine learning." },
      { icon: "🗺️", title: "Spatial Intelligence", desc: "Every insight is geo-referenced, enabling spatial analysis and map-based operations." },
      { icon: "🔋", title: "DER Integration", desc: "Visibility and control of distributed energy resources including solar, storage, and EVs." },
      { icon: "📋", title: "Regulatory Reporting", desc: "Automated compliance reporting aligned to regional grid regulatory requirements." },
    ],
    capabilities: [
      { icon: "🔗", title: "Unified Data Layer", desc: "Ingest, normalise, and federate data from GIS, SCADA, AMI, OMS, and ERP into one coherent model." },
      { icon: "📊", title: "Real-Time Network Visibility", desc: "Live network state awareness from substation to meter, with anomaly detection and alerting." },
      { icon: "🤖", title: "AI-Powered Predictions", desc: "Predictive fault detection, load forecasting, and asset health scoring using machine learning." },
      { icon: "🗺️", title: "Spatial Intelligence", desc: "Every insight is geo-referenced, enabling spatial analysis and map-based operations." },
      { icon: "🔋", title: "DER Integration", desc: "Visibility and control of distributed energy resources including solar, storage, and EVs." },
      { icon: "📋", title: "Regulatory Reporting", desc: "Automated compliance reporting aligned to regional grid regulatory requirements." },
    ],
    outcomes: [
      { val: "40%", label: "Reduction in Outage Duration" },
      { val: "3x", label: "Faster Fault Isolation" },
      { val: "25%", label: "OPEX Reduction" },
      { val: "99.9%", label: "Network Data Accuracy" },
    ],
    whoFor: ["Electricity distribution and transmission operators", "Smart grid and AMI programme managers", "Utilities managing DER integration", "Grid operations centres requiring real-time visibility"],
  },

  // ── CONDUITPRO ────────────────────────────────────────────────
  "product-conduitpro": {
    icon: "",
    title: "ConduitPro®",
    badge: "Conduit Management Platform",
    tagline: "Intelligent Conduit & Utility Network Management Platform Master conduit complexity. Unlock Utility Network value.",
    color: "#E8601C",
    desc: "ConduitPro® is Inovaantage's purpose-built, enterprise-grade conduit and duct network management platform, designed to address one of the most persistent challenges in modern utility and telecom networks — accurate, usable, and scalable conduit data within the ESRI Utility Network. Built natively on ESRI technology, ConduitPro extends Utility Network capabilities by providing deep conduit intelligence, association management, and operational visibility that standard GIS configurations and legacy solutions struggle to deliver.",
    whyDifferent: [
      { icon: "🎯", title: "Designed for Utility Network, not retrofitted", desc: "Unlike legacy products optimised for ESRI Geometric Network, ConduitPro is engineered specifically for the Utility Network data model, fully embracing containment, association, and rule-based behaviour." },
      { icon: "🔑", title: "Solves the hardest problem in Utility Network adoption", desc: "Conduit and duct data is often the least reliable and most business-critical component of utility GIS. ConduitPro directly addresses this with structured, governed, and scalable conduit management." },
      { icon: "🌐", title: "Native ESRI platform alignment", desc: "Operates natively within the ESRI ecosystem — compatible with Utility Network upgrades, ArcGIS Pro, and enterprise workflows, with no data duplication or external dependencies." },
      { icon: "🏛️", title: "Enterprise-grade, regulator-ready", desc: "Designed for regulated utilities and large telecom operators, ConduitPro supports auditability, governance, and long-term operational assurance." },
    ],
    capabilities: [
      { icon: "🏗️", title: "Conduit Hierarchy Management", desc: "Manage multi-level conduit, duct, and sub-duct structures with full spatial and logical integrity." },
      { icon: "🔗", title: "Association & Containment Intelligence", desc: "Accurately model how cables, fibres, and assets are placed, shared, and reused across networks." },
      { icon: "✅", title: "Utility Network Rule Enforcement", desc: "Ensure compliance with Utility Network rules, asset packages, and lifecycle states." },
      { icon: "🔍", title: "Data Quality & Validation", desc: "Detect inconsistencies, missing associations, and structural errors before they impact operations." },
      { icon: "🔄", title: "Migration & Transition Support", desc: "Works seamlessly with rUNr® to transition legacy conduit data into Utility Network-compliant structures." },
      { icon: "📊", title: "Operational & Planning Enablement", desc: "Provides reliable data for network planning, capacity management, and field operations." },
    ],
    outcomes: [
      { val: "90%+", label: "Improvement in Data Completeness" },
      { val: "60%", label: "Faster Route Planning" },
      { val: "Zero", label: "Cable-Conduit Conflicts Post-Deployment" },
      { val: "100%", label: "Regulatory Data Compliance" },
    ],
    whoFor: ["Telecom operators managing fibre, duct, and conduit infrastructure", "Utilities with complex underground asset networks", "Organisations migrating from Geometric Network to Utility Network", "Asset owners requiring accurate conduit capacity and utilisation insight"],
    typicalOutcomes: [
      "Significant improvement in conduit data accuracy and trust",
      "Reduced design rework and construction risk",
      "Faster Utility Network adoption and stabilisation",
      "Improved planning, capacity utilisation, and asset reuse",
    ],
    deliveredBy: "ConduitPro is delivered by Inovaantage's specialist Utility Network and GIS engineers, combining deep ESRI expertise with real-world utility and telecom deployment experience. Together with rUNr®, ConduitPro enables utilities to migrate, govern, and operationalise conduit data with confidence.",
    closingTagline: "ConduitPro® – because conduit intelligence is foundational to modern utility networks.",
  },

  // ── ELECTRICITY / SLD ─────────────────────────────────────────
  "product-electricity": {
    icon: "",
    title: "SLD — Electrical Schematic Platform",
    badge: "Intelligent SLD Management",
    tagline: "Transforming Electrical Design with Smart, GIS-Integrated SLDs.",
    color: "#E8601C",
    desc: "Inovaantage's Electrical Schematic Platform is designed to meet the evolving needs of electrical engineers and utility operators. This platform enables the creation, management, and visualisation of Single Line Diagrams (SLDs) with precision, efficiency, and full compatibility with any GIS system. By bridging schematic design and spatial data, organisations can streamline operations, enhance network planning, and maintain accurate digital records of their electrical infrastructure.",
    whyDifferent: [
      { icon: "🔗", title: "GIS-Integrated SLDs", desc: "Seamlessly synchronise your SLDs with any GIS platform, ensuring that spatial data and electrical schematics are always aligned. This eliminates discrepancies between network diagrams and geospatial representations." },
      { icon: "⚡", title: "Intelligent Electrical Diagramming", desc: "Create precise and standardised SLDs with automated component placement, error detection, and validation rules. Reduce manual design errors, save engineering time, and maintain compliance with industry standards." },
      { icon: "🔄", title: "Real-Time Updates & Version Control", desc: "Ensure that SLDs reflect the latest network changes with real-time updates and robust version control. Engineers can track modifications, manage approvals, and maintain a reliable audit trail for regulatory compliance." },
      { icon: "☁️", title: "Flexible Deployment & Customisation", desc: "Whether on-premises or cloud, the platform adapts to your IT environment. Customisable templates and workflows enable utilities to align the system with internal processes and reporting requirements." },
    ],
    capabilities: [
      { icon: "🗺️", title: "GIS-Integrated SLDs", desc: "Seamlessly synchronise SLDs with any GIS platform for aligned spatial and schematic data." },
      { icon: "📐", title: "Intelligent Electrical Diagramming", desc: "Automated component placement, error detection, and validation rules for precision SLD creation." },
      { icon: "🔄", title: "Real-Time Updates & Version Control", desc: "Track modifications, manage approvals, and maintain a reliable audit trail for regulatory compliance." },
      { icon: "📊", title: "Advanced Visualisation & Analysis", desc: "Visualise electrical networks in intuitive, interactive diagrams — connectivity, load flow, and fault analysis." },
      { icon: "☁️", title: "Flexible Deployment", desc: "On-premises or cloud deployment with customisable templates and workflows." },
      { icon: "🤝", title: "Improved Collaboration", desc: "Facilitate cross-team collaboration between electrical engineers, GIS specialists, and operations teams." },
    ],
    outcomes: [
      { val: "100%", label: "GIS–SLD Data Alignment" },
      { val: "50%", label: "Faster Diagram Creation" },
      { val: "Zero", label: "Schematic–Spatial Discrepancies" },
      { val: "Full", label: "Regulatory Audit Trail" },
    ],
    whoFor: ["Electrical engineers and design teams", "Electricity distribution and transmission utilities", "Organisations requiring GIS-schematic integration", "Regulated utilities needing audit trails for electrical diagrams"],
  },

  // ── rUNr ─────────────────────────────────────────────────────
  "product-runr": {
    icon: "",
    title: "rUNr®",
    badge: "Automated Utility Network Migration Platform",
    tagline: "Migrate with certainty. Operate with confidence.",
    color: "#E8601C",
    desc: "rUNr® is Inovaantage's proprietary, enterprise-grade GIS data migration and transformation platform, purpose-built to automate the migration of legacy ESRI Geometric Network and non-standard utility datasets into the ESRI Utility Network with near-perfect accuracy. Designed for regulated, mission-critical environments, rUNr eliminates the risk, cost, and disruption traditionally associated with large-scale GIS migrations. Unlike generic ETL scripts or manual FME-based approaches, rUNr provides a repeatable, auditable, and industrialised migration framework trusted by utilities and telecom operators globally.",
    whyDifferent: [
      { icon: "🎯", title: "Built specifically for Utility Network", desc: "Most migration tools treat Utility Network as a target schema. rUNr understands it as a behavioural model — handling associations, network rules, asset packages, and lifecycle states natively." },
      { icon: "✅", title: "99.99% Migration Accuracy", desc: "rUNr consistently delivers near-zero defect migrations, removing the need for prolonged post-migration clean-up or production stabilisation phases." },
      { icon: "⚙️", title: "Not just FME — engineered on top of it", desc: "While rUNr leverages Safe Software's FME engine, it extends far beyond raw ETL with pre-built migration patterns, rule orchestration, automated validation, reconciliation, and exception handling at scale." },
      { icon: "🏛️", title: "Designed for regulated environments", desc: "Every migration step is auditable, repeatable, and explainable, supporting regulatory scrutiny, governance, and change assurance." },
      { icon: "🔄", title: "Cutover without disruption", desc: "rUNr enables parallel run and controlled cutover strategies, ensuring business-as-usual operations during migration programmes." },
      { icon: "🌐", title: "Multi-platform versatility", desc: "Proven variants supporting GE Smallworld upgrades, cross-version GIS upgrades, migration from proprietary platforms, and consolidation of fragmented GIS systems." },
    ],
    capabilities: [
      { icon: "📋", title: "Source System Normalisation", desc: "Standardises fragmented and inconsistent legacy GIS datasets prior to migration." },
      { icon: "🔗", title: "Utility Network Rule Mapping", desc: "Automatically maps connectivity, containment, and association rules to Utility Network standards." },
      { icon: "✅", title: "Automated Validation & QA", desc: "Embedded validation checks detect errors before data reaches production systems." },
      { icon: "⚠️", title: "Exception Management", desc: "Isolates and reports true data issues without halting migration runs." },
      { icon: "🔁", title: "Repeatable Migration Runs", desc: "Enables multiple dry runs, test cycles, and rehearsal migrations before production cutover." },
      { icon: "📦", title: "Production-Ready Outputs", desc: "Delivers clean, compliant Utility Network datasets ready for immediate operational use." },
    ],
    outcomes: [
      { val: "70–90%", label: "Reduction in Migration Timelines" },
      { val: "Zero", label: "Manual Correction Teams Needed" },
      { val: "99.99%", label: "Migration Accuracy" },
      { val: "100%", label: "Auditability & Traceability" },
    ],
    whoFor: ["Electricity, gas, water, and telecom utilities migrating to ESRI Utility Network", "Organisations with large, complex, or poor-quality legacy GIS data", "Utilities requiring zero or minimal outage during migration", "Regulated asset owners needing auditability and assurance"],
  },

  // ── ENERGIZE / DE-ENERGIZE ────────────────────────────────────
  "product-energize": {
    icon: "",
    title: "Energize & De-energize",
    badge: "GIS-Based Outage Management System",
    tagline: "Optimising Electrical Distribution with Real-Time Outage Management.",
    color: "#E8601C",
    desc: "Inovaantage's Energize & De-energize is a cutting-edge GIS-based Outage Management System (OMS) designed for electrical distribution utilities. The platform empowers utilities to monitor, manage, and restore electrical outages efficiently, enhancing reliability, operational efficiency, and customer satisfaction. By leveraging spatial intelligence and advanced analytics, Energize & De-energize transforms how utilities respond to network disruptions and plan proactive maintenance.",
    whyDifferent: [
      { icon: "🗺️", title: "GIS-First Outage Intelligence", desc: "Every outage is visualised and managed within the spatial context of the live network model — enabling decisions informed by accurate, real-time geographic data." },
      { icon: "⚡", title: "Automated Detection & Rapid Response", desc: "Smart sensor integration and SCADA connectivity enable instant outage detection and automated notifications, minimising customer downtime." },
      { icon: "📊", title: "Load Management & Sectionalising", desc: "Analyse fault conditions, evaluate network impact, and determine optimal switching strategies to safely and rapidly restore supply." },
      { icon: "🚒", title: "Optimised Crew Dispatch", desc: "Assign field crews efficiently using real-time GIS data and automated task prioritisation, reducing travel time and improving coordination." },
    ],
    capabilities: [
      { icon: "🗺️", title: "GIS-Integrated Outage Tracking", desc: "Visualise the entire distribution network in real-time, pinpoint outage locations, and assess affected assets using GIS mapping." },
      { icon: "🔔", title: "Automated Outage Detection & Notification", desc: "Receive instant alerts of network disruptions through smart sensors, SCADA integration, and automated reporting tools." },
      { icon: "⚡", title: "Fault Analysis & Load Management", desc: "Analyse fault conditions, evaluate network impact, and determine optimal switching strategies including load balancing and sectionalising." },
      { icon: "🚒", title: "Crew Dispatch & Workflow Optimisation", desc: "Assign field crews efficiently using real-time GIS data and automated task prioritisation to reduce travel time." },
      { icon: "📈", title: "Historical Analysis & Reporting", desc: "Track outage patterns, downtime statistics, and performance metrics to support regulatory compliance and preventive maintenance." },
      { icon: "🔄", title: "Real-Time Network Restoration", desc: "Support step-by-step restoration workflows validated against the live GIS network model for safety and compliance." },
    ],
    outcomes: [
      { val: "75%", label: "Reduction in Outage Response Time" },
      { val: "50%", label: "Faster Programme Creation" },
      { val: "100%", label: "Digital Audit Trail Coverage" },
      { val: "Zero", label: "Safety Incidents Post-Implementation" },
    ],
    whoFor: ["Electricity distribution utilities managing outage response", "Network operations centres requiring real-time situational awareness", "Utilities seeking GIS-SCADA integration for outage management", "Regulated utilities needing compliant restoration audit trails"],
  },

  // ── FUEERZA ───────────────────────────────────────────────────
  "product-fueerza": {
    icon: "",
    title: "Fueerza",
    badge: "Intelligent Field Force Management",
    tagline: "Empowering Field Teams. Driving Operational Excellence.",
    color: "#E8601C",
    desc: "Inovaantage's Fueerza is a powerful Field Force Management System designed to streamline the operations of mobile teams across industries. Fueerza enables organisations to plan, track, and optimise field activities in real-time, enhancing productivity, accountability, and customer satisfaction. Built for modern enterprises, the platform combines intuitive mobile tools, robust reporting, and seamless task management to empower your field workforce.",
    whyDifferent: [
      { icon: "📱", title: "Mobile-First, Offline-Ready", desc: "Field teams access Fueerza on mobile devices with full offline support, ensuring uninterrupted workflow even in remote or connectivity-limited areas." },
      { icon: "📍", title: "Real-Time GPS Tracking", desc: "Monitor field workforce activities live through GPS-enabled tracking and status updates, enabling proactive management decisions." },
      { icon: "⚙️", title: "Fully Configurable Workflows", desc: "Adapt Fueerza to your business processes with configurable workflows, approvals, and task hierarchies — a solution truly tailored to your organisation." },
      { icon: "📊", title: "Data-Driven Operations", desc: "Collect field data including forms, images, signatures, and notes, then generate detailed analytics to measure performance and optimise operations." },
    ],
    capabilities: [
      { icon: "📋", title: "Task Planning & Scheduling", desc: "Assign tasks to field agents with automated scheduling, route optimisation, and priority management — the right work to the right team at the right time." },
      { icon: "📍", title: "Real-Time Tracking & Monitoring", desc: "Monitor field workforce activities live through GPS-enabled tracking and status updates, with visibility into task progress, location, and time spent." },
      { icon: "📱", title: "Mobile Access & Offline Capabilities", desc: "Field teams access Fueerza on mobile devices with offline support, ensuring uninterrupted workflow in remote areas." },
      { icon: "📊", title: "Data Capture & Reporting", desc: "Collect field data including forms, images, signatures, and notes. Generate detailed reports and analytics to measure performance and identify bottlenecks." },
      { icon: "💬", title: "Collaboration & Communication", desc: "Integrated messaging, alerts, and notifications facilitate effective communication between field agents and office teams." },
      { icon: "⚙️", title: "Customisable Workflows", desc: "Configurable workflows, approvals, and task hierarchies adapt Fueerza to your organisation's specific business processes." },
    ],
    outcomes: [
      { val: "40%+", label: "Improvement in Field Productivity" },
      { val: "100%", label: "Real-Time Field Visibility" },
      { val: "60%", label: "Reduction in Admin Overhead" },
      { val: "24/7", label: "Platform Availability" },
    ],
    whoFor: ["Utilities managing large field engineer and technician workforces", "Telecoms with field installation and maintenance teams", "Infrastructure operators coordinating multi-site field operations", "Any organisation requiring real-time visibility of mobile workforce activity"],
  },
};

export default function ProductsSubPage({ page }) {
  const data = productData[page];
  if (!data) return null;

  return (
    <div className="subpage-root">

      {/* ── HERO ── */}
      <section className="subpage-hero" style={{ "--accent": data.color }}>
        <div className="subpage-hero-badge">
          <span className="subpage-icon">{data.icon}</span>
          <span>Offerings → Products → {data.badge}</span>
        </div>
        <h1 className="subpage-title">{data.title}</h1>
        <p className="subpage-tagline">{data.tagline}</p>
      </section>

      {/* ── OVERVIEW ── */}
      <section className="subpage-section">
        <div className="subpage-container">
          <div className="subpage-overview-card">
            <h2>About {data.title}</h2>
            <p>{data.desc}</p>
          </div>
        </div>
      </section>

      {/* ── WHY DIFFERENT ── */}
      {data.whyDifferent && (
        <section className="subpage-section alt">
          <div className="subpage-container">
            <h2 className="subpage-section-title" style={{color:"#1A1A1A"}}>Why {data.title} Is Different</h2>
            <div className="subpage-grid-2">
              {data.whyDifferent.map((w, i) => (
                <div key={i} className="product-why-card" style={{ "--accent": data.color }}>
                  <div className="product-why-icon">{w.icon}</div>
                  <div>
                    <h3 className="product-why-title">{w.title}</h3>
                    <p className="product-why-desc">{w.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      )}

      {/* ── KEY CAPABILITIES ── */}
      <section className="subpage-section">
        <div className="subpage-container">
          <h2 className="subpage-section-title">Key Capabilities</h2>
          <div className="subpage-grid-3">
            {data.capabilities.map((f, i) => (
              <div key={i} className="subpage-cap-card" style={{ "--accent": data.color }}>
                <span className="subpage-cap-icon">{f.icon}</span>
                <h3>{f.title}</h3>
                <p>{f.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── OUTCOMES ── */}
      <section className="subpage-section alt">
        <div className="subpage-container">
          <h2 className="subpage-section-title" style={{color:"#1A1A1A"}}>Measurable Outcomes</h2>
          <div className="subpage-outcomes-grid">
            {data.outcomes.map((o, i) => (
              <div key={i} className="subpage-outcome-card" style={{ "--accent": data.color }}>
                <span className="subpage-outcome-val">{o.val}</span>
                <span className="subpage-outcome-label">{o.label}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── WHO IT'S FOR ── */}
      {data.whoFor && (
        <section className="subpage-section">
          <div className="subpage-container">
            <h2 className="subpage-section-title">Who {data.title} Is For</h2>
            <div className="product-whofor-grid">
              {data.whoFor.map((w, i) => (
                <div key={i} className="product-whofor-item" style={{ "--accent": data.color }}>
                  <span className="product-whofor-arrow" style={{ color: data.color }}>→</span>
                  <span>{w}</span>
                </div>
              ))}
            </div>
          </div>
        </section>
      )}

      {/* ── Delivered by Inovaantage ── */}
      {data.deliveredBy && (
        <section className="subpage-section">
          <div className="subpage-container">
            <h2 className="subpage-section-title">Delivered by Inovaantage</h2>

            <p>ConduitPro is delivered by Inovaantage’s specialist Utility Network and GIS engineers, combining deep ESRI expertise with real-world utility and telecom deployment experience.
              Together with rUNr®, ConduitPro enables utilities to migrate, govern, and operationalise conduit data with confidence.</p>
          </div>

        </section>
      )}

      {/* ── CTA ── */}
      <section className="subpage-section alt">
        <div className="subpage-container" style={{ textAlign: "center" }}>
          <div className="product-cta-box">
            <h2>Ready to learn more about {data.title}?</h2>
            <p>Contact our specialist team to arrange a demo or discuss your requirements.</p>
            <a href="mailto:info@inovaantage.com" className="product-cta-btn" style={{ background: `linear-gradient(135deg, ${data.color}, #F4A340)` }}>
              Contact Us → info@inovaantage.com
            </a>
          </div>
        </div>
      </section>

    </div>
  );
}
